import React from "react";
import { useSelector } from "react-redux";
import {
  selectPublicTournament,
  selectTournamentSponsors,
  selectTournamentSponsorshipTiers,
} from "../../reducers/tournamentSlice";
import TechSponsorLineItem from "../events/tech-sponsor-line-item";
import {
  defaultGapping,
  defaultLayouts,
  defaultTypography,
  GSItemList,
} from "golfstatus_react_components";

export const useTechSponsors = (eventDetailsView = false) => {
  const tournament = useSelector(selectPublicTournament);
  const sponsorships = useSelector(selectTournamentSponsors);
  const sponsorshipTiers = useSelector(selectTournamentSponsorshipTiers);

  const techSponsors = sponsorships?.filter?.(
    (sponsor) => sponsor.sponsorshipType === "leaderboard"
  );

  const techTier = sponsorshipTiers?.find?.(
    (tier) => tier?.sponsorshipTierType === "technology"
  );

  const getTechSponsorSections = () => {
    const sponsors = [];

    if (tournament?.tournamentPromotion?.secondaryEventPhoto) {
      sponsors.unshift(
        <TechSponsorLineItem
          logo={tournament?.tournamentPromotion?.secondaryEventPhoto}
          message={tournament?.tournamentPromotion?.secondaryEventPhotoText}
        />
      );
    }

    if (techSponsors?.length > 0) {
      eventDetailsView
        ? sponsors.unshift(
            <div
              style={{ ...defaultLayouts.vStack, ...defaultGapping.largeGap, ...defaultLayouts.fullWidth }}
            >
              <div style={{ ...defaultTypography.headline3 }}>
                {techTier?.name}
              </div>
              <GSItemList
                items={techSponsors}
                type="vertical"
                style={{ width: "100%" }}
                listItem={(sponsor) => (
                  <TechSponsorLineItem style={{ width: "100%" }} {...sponsor} />
                )}
              />
            </div>
          )
        : sponsors.unshift(
            <GSItemList
              items={techSponsors}
              type="vertical"
              style={{ width: "100%" }}
              listItem={(sponsor) => (
                <TechSponsorLineItem style={{ width: "100%" }} {...sponsor} />
              )}
            />
          );
    }

    return sponsors;
  };

  return [getTechSponsorSections];
};
